import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { Elements } from '@stripe/react-stripe-js'
import { loadStripe } from '@stripe/stripe-js'

import Spacer from 'components/Spacer'
import Row from 'components/Row'
import { post } from 'service/api'

import Container from './styles'
import CheckoutForm from './CheckoutForm'
import SubscriptionForm from './SubscriptionForm'

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_KEY)

export default function Checkout() {
  const { t } = useTranslation()
  const info = useSelector((state) => state.info)
  const history = useHistory()

  useEffect(() => {
    if (!info.type || info.type === '') {
      history.replace('/')
    }
  }, [history, info.type])

  async function handleOnSuccess(id) {
    const res = await post({ url: '/data', data: { ...info, stripeID: id } })
    if (!res) return console.log('ERROR')
    return history.replace('/success')
  }

  return (
    <Container>
      <Spacer height={30} />
      <h1>{t('checkout.title')}</h1>
      <Spacer height={50} />

      <Elements stripe={stripePromise}>
        {info.type === 'hours' && (
          <CheckoutForm info={info} onSuccess={handleOnSuccess} />
        )}
        {info.type === 'databases' && (
          <SubscriptionForm info={info} onSuccess={handleOnSuccess} />
        )}
      </Elements>
      <Spacer height={50} />
      <Row justify="center">
        <img
          src="/assets/images/stripe.svg"
          className="stripe"
          alt="Powered by Stripe"
        />
      </Row>
    </Container>
  )
}
